var __jsx = React.createElement;
import React from "react";
import { useTranslation } from "@i18n";
import { formatNumberWithCommas, getArabicYearWord } from "@/utils/stringHelpers";
import EditeIcon from "@/pages/checkout/arib-finance/component/FinanceDetailsBox/EditeIcon";
import { trackEvents } from "@/common/events/events";
var FinanceDetailsCard = function FinanceDetailsCard(_ref) {
  var title = _ref.title,
    installmentPeriod = _ref.installmentPeriod,
    down_payment = _ref.down_payment,
    last_payment = _ref.last_payment,
    monthly_installment = _ref.monthly_installment,
    _ref$showEditIcon = _ref.showEditIcon,
    showEditIcon = _ref$showEditIcon === void 0 ? false : _ref$showEditIcon,
    onEditClick = _ref.onEditClick;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var handleEditClick = function handleEditClick() {
    var _location;
    onEditClick === null || onEditClick === void 0 ? void 0 : onEditClick();
    var urlParams = new URLSearchParams((_location = location) === null || _location === void 0 ? void 0 : _location.search);
    var financeStep = urlParams.get('financestep');
    trackEvents("edit_calculator_clicked", {
      referral_location: "form".concat(financeStep !== null && financeStep !== void 0 ? financeStep : "1")
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-white rounded shadow-[0px_0px_4px_0px_rgba(0,0,0,0.04)] overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-r-2 en:border-l-2 en:border-r-0 border-solid border-primary px-6 py-5 w-full flex justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-xs font-medium leading-4"
  }, t("request_financing", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#383838] text-sm font-bold leading-6 overflow-hidden"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-xs leading-4"
  }, t("installment_starts", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-primary"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xl font-bold"
  }, monthly_installment && formatNumberWithCommas(monthly_installment))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-primary text-xl"
  }, t("sar", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-primary text-sm"
  }, "/"), /*#__PURE__*/React.createElement("p", {
    className: "text-primary text-sm"
  }, t("monthly", {
    ns: "web_common"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-[#697A8F0D] rounded-lg flex items-center justify-between pr-3 pl-4 en:pl-3 en:pr-4 py-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6C7A8D] text-xs font-medium leading-4"
  }, t("installment_duration", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#383838] text-sm font-bold leading-6"
  }, installmentPeriod / 12, " ", getArabicYearWord(installmentPeriod / 12, t))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6C7A8D] text-xs font-medium leading-4"
  }, t("down_payment", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#383838] text-sm font-bold leading-6"
  }, down_payment && formatNumberWithCommas(down_payment), " ", t("sar", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6C7A8D] text-xs font-medium leading-4"
  }, t("last_payment", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#383838] text-sm font-bold leading-6"
  }, last_payment && formatNumberWithCommas(last_payment), " ", t("sar", {
    ns: "web_checkout_finance"
  }))), showEditIcon && /*#__PURE__*/React.createElement("div", {
    onClick: handleEditClick,
    style: {
      display: 'inline-block',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(EditeIcon, {
    className: "cursor-pointer"
  })))));
};
export default FinanceDetailsCard;